export const INFO_BLOCKS = {
  PersonalData: "PersonalData",
  Shipment: "Shipment",
  StoreShipping: "StoreShipping",
  CashOnDelivery: "CashOnDelivery",
  PrepaidActivation: "PrepaidActivation",
  Installation: "Installation",
  Landline: "Landline",
  PackMobile: "PackMobile",
  Mobile: "Mobile",
  Account: "Account",
  SelectLine: "SelectLine",
  MultiSimSelections: "MultiSimSelections",
}